import { Form } from "@/atoms"

import styles from "./CloudConnectionStatus.module.scss"

import type { CloudConnectionFieldsProps } from "./CloudConnectionStatus.types"

// The settings of a cloud connection, evenly spaced
export const CloudConnectionFields = ({
  children
}: CloudConnectionFieldsProps) => (
  <Form layout="vertical" component="div" className={styles.fields}>
    {children}
  </Form>
)
